import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Card } from '@material-ui/core';
import UserIcon from '@material-ui/icons/AccountCircle';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../constants/styleConstants';
import { route } from '../../constants/routes';
import { getRouteWithSlug } from '../../utils/common';
import NextLink from '../NextLink';
import ImageTag from '../ImageTag';

const useStyles = makeStyles(theme => ({
  artist: props => ({
    width: props.size === 'small' ? 99 : 171,
    height: props.size === 'small' ? 137 : 228,
    position: 'relative',
    borderRadius: 2,
    boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.15)',
    [theme.breakpoints.down('xs')]: {
      width: 99,
      height: 137,
    },
  }),
  artistInfo: props => ({
    position: 'absolute',
    bottom: 0,
    paddingTop: '2px',
    minHeight: props.size === 'small' ? 35 : 55,
    backgroundColor: 'rgba(0,0,0,0.7)',
    width: props.size === 'small' ? 99 : 171,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    '&> *': {
      marginLeft: props.size === 'small' ? 5 : 10,
      color: colors.white,
    },
    [theme.breakpoints.down('xs')]: {
      width: 99,
    },
  }),
  artistName: props => ({
    fontSize: props.size === 'small' ? 11 : 14,
    lineHeight: 1,
    [theme.breakpoints.down('xs')]: {
      fontSize: 10,
    },
  }),
  artistType: props => ({
    fontSize: props.size === 'small' ? 9 : 13,
    [theme.breakpoints.down('xs')]: {
      fontSize: 8,
    },
  }),
  photoBox: {
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  photo: {
    objectFit: 'cover',
    objectPosition: 'top',
  },
  icon: {
    width: '100%',
    height: 'calc(100% - 55px)',
  },
}));

const ArtistCard = props => {
  const classes = useStyles(props);

  const { artist, size } = props;
  const name = get(artist, 'name');

  const imageWidth = size === 'small' ? 99 : 171;
  const imageHeight = size === 'small' ? 137 : 228;

  return (
    <NextLink href={`${route.ARTISTS}/[id]/[[...action]]`} as={getRouteWithSlug(route.ARTISTS, artist)}>
      <Card className={classes.artist} size={size} title={name}>
        {get(artist, 'image.medium') ? (
          <ImageTag
            width={imageWidth}
            height={imageHeight}
            src={get(artist, 'image.medium')}
            alt="artist_image"
            className={classes.photo}
            lazyLoad
          />
        ) : (
          <UserIcon className={classes.icon} />
        )}
        <div className={classes.artistInfo}>
          <div className={classes.artistName}>{name}</div>
          <div className={classes.artistType}>
            {get(artist, 'profession.qualification.name') || get(artist, 'profession.name') || get(artist, 'summary')}
          </div>
        </div>
      </Card>
    </NextLink>
  );
};

ArtistCard.propTypes = {
  artist: PropTypes.object,
  size: PropTypes.string,
};

export default ArtistCard;
